export default "__VITE_ASSET__BaVV$yFy__"